export default class ShopModal {

    constructor($view) {
        this.$view = $view;
        this.txtVille = this.$view.find("[data-field='ville']");
        this.btnVille = this.$view.find("[data-search='ville']");
        this.url = this.$view.data('url');
        this.citiesApi = this.txtVille.data('url');
        this.citiesResult = this.$view.find("[data-target='villes']");
        this.product = this.$view.data('product');
        this.error_mesage = this.$view.find("[data-error]").data("error");
        this.reset = this.$view.find("[data-reset='true']");
        // Debounce KeyUp
		this.timeout;
		this.delay = 1000;
        this.bind();
    }

    bind() {
        var self = this;

        this.txtVille.on('keyup', function (e) {

            if(self.timeout) {
                clearTimeout(self.timeout);
            }
            self.timeout = setTimeout(function() {

                if (e.which == 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    var first = $(self.citiesResult).find("a:first");
                    if (first.length > 0) {
                        first[0].click();
                        self.citiesResult.html('');
                    }

                    return false;
                }
                self.citiesResult.html('');
                var search = self.txtVille.val();
                if (search.length >= 3) {
                    $.getJSON(self.citiesApi + '?search=' + search, function (data) {
                        self.citiesResult.html("");
                        for (var i in data) {
                            self.citiesResult.append("<li><a href='#' data-id='" + data[i].id + "'>" + data[i].zip_code + " - " + data[i].name + "</a></li>");
                        }
                    });
                } else if (search.length == 0) {
                    // vide : reset
                    var url = self.url;
                    if (url.indexOf("?") >= 0) {
                        url += "&";
                    } else {
                        url += "?";
                    }
                    if (self.product) {
                        url += encodeURI($.param(self.product)) + "&";
                    }
                    Api.GET(url);
                }
                
            }, self.delay);

            // si on tape Entrée, on sélectionne le premier résultat
        });
        this.reset.on("click", function() {
            self.txtVille.val('');
            self.citiesResult.html('');
            let url = self.url;
            if (url.indexOf("?")>=0) {
                url += "&";
            } else {
                url += "?";
            }
            if (self.product) {
                url += encodeURI($.param(self.product)) + "&";
            }
            Api.GET(url);
        });

        this.citiesResult.on('click','a', function (e) {
            let url = self.url;
            if (url.indexOf("?")>=0) {
                url += "&";
            } else {
                url += "?";
            }
            if (self.product) {
                url += encodeURI($.param(self.product)) + "&";
            }

            self.txtVille.val($(this).html());
            url = url + "city=" + $(this).data("id");
            if(self.$view.find('.store-locator-quote').length > 0){
                url = url + "&quote=1"
            }

            Api.GET(url);
            self.citiesResult.html('');
        });

        this.$view.on('click', '.js-show-map', function (e) {
            let id = $(this).data('id');
            selectMarker(id, true);
        });

        this.$view.on('click', '.js-choix-magasin', function (e) {
            let url = $(this).data('url');
            if (self.product) {
                url += "&" + encodeURI($.param(self.product));
            }
            Api.GET(url);
        });


        this.$view.on('click', '.close', function (e) {
            $(this).parents(".modal").first().removeClass("show").css('display', 'none');
            if(!$(this).parents(".modal").first().hasClass('shop-added')){
                if (self.product && self.product.product) {
                    toastr["error"](self.error_mesage);
                }
            }

        });

    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/ShopModal.js